import clsx from 'clsx';
import { Overlay } from './Overlay';

type KnoxDialogProps = {
  open: boolean;
  onClose: () => void;
  title?: string;
  variant?: 'surface' | 'critical';
  children: React.ReactNode;
  className?: string;
  /** Handle Enter key press at dialog level */
  onKeyDown?: React.KeyboardEventHandler;
};

/**
 * Knox Dialog — replaces folds Dialog + Header.
 * Built on top of Knox Overlay (headlessui Dialog).
 */
export function KnoxDialog({
  open,
  onClose,
  title,
  variant = 'surface',
  children,
  className,
  onKeyDown,
}: KnoxDialogProps) {
  return (
    <Overlay open={open} onClose={onClose}>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        className={clsx(
          'rounded-xl shadow-lg',
          'bg-surface text-foreground',
          className,
        )}
        style={{ width: 672, maxWidth: '100%' }}
        onKeyDown={onKeyDown}
      >
        {/* Header */}
        {title && (
          <div
            className={clsx(
              'flex items-center justify-between px-6 py-4',
              'border-b border-outline-variant',
            )}
          >
            <h2
              className={clsx(
                'knox-text-h4',
                variant === 'critical' && 'text-destructive',
              )}
            >
              {title}
            </h2>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              className={clsx(
                'flex items-center justify-center rounded-full p-1',
                'text-on-surface-variant hover:bg-surface-container-high',
                'transition-colors duration-150',
              )}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
        )}

        {/* Content */}
        <div className="px-6 py-4">{children}</div>
      </div>
    </Overlay>
  );
}
